// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconAdjustmentsHorizontal,IconFileAnalytics, IconAddressBook, IconChartHistogram, IconTemplate } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - REPORTS ||============================== //

const icons = {
    IconAdjustmentsHorizontal,
    IconFileAnalytics,
    IconAddressBook,
    IconChartHistogram,
    IconTemplate
};
const reports: NavItemType = {
  id: 'reportsSection',
  title: <FormattedMessage id="Reports" />,
  type: 'group',
  children: [
    {
 
                id: 'report-route',
                title: <FormattedMessage id="Route report" />,
                type: 'item',
                icon: icons.IconFileAnalytics,
                url: '/report/route',
                target: false
            },
            {
                id: 'report-profile',
                title: <FormattedMessage id="Profile report" />,
                type: 'item',
                icon: icons.IconAddressBook,
                url: '/report/profile',
                target: false
            },
            {
                id: 'metrics',
                title: <FormattedMessage id="Metrics" />,
                type: 'item',
                icon: icons.IconChartHistogram,
                url: '/metrics',
                target: false
            },
            {
                id: 'report-templates',
                title: <FormattedMessage id="Templates" />,
                type: 'item',
                icon: icons.IconTemplate,
                url: '/report/templates',
                target: false
            }
        ]
};

export default reports;
